// Helper to generate a smaller Cloudinary URL for thumbnails
export const getThumbnailUrl = (url) => {
  if (!url) return url;
  if (!url.includes('res.cloudinary.com') || !url.includes('/upload/') || url.includes('/upload/c_')) {
    return url;
  }
  return url.replace('/upload/', '/upload/c_limit,w_300,f_auto,q_auto/');
};
